import { useField } from "formik";
import {
  AddUserDoctorRequestUserGenderEnum,
  AddUserDoctorRequestUserBloodTypeEnum,
  AddUserDoctorRequestUserMaritalStatusEnum
} from "../../../../api/clinic-management";
import keyLabel from "../../../../utils/keylabel";
import { Grid, Typography, Divider, Box } from "@mui/material";
import DatePicker from "../../../../utils/FormFields/DatePicker";
import { FileBodyTypeEnum } from "../../../../api/file-management";
import UploadField from "../../../../utils/FormFields/UploadField";
import { InputField, SelectField } from "../../../../utils/FormFields";

const gender = keyLabel(AddUserDoctorRequestUserGenderEnum);
const bloodTypes = keyLabel(AddUserDoctorRequestUserBloodTypeEnum);
const maritalStatus = keyLabel(AddUserDoctorRequestUserMaritalStatusEnum);

export default function PatientInfo() {
  const [ meta] = useField('User.DateOfBirth');  

  const calculateAgeFromDate = (dateString: any) => {
    if(!dateString){
      return 0;
    }

    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  };
  
  return (
    <>
      <Typography variant="h5" gutterBottom sx={{ p: 0 }}>
        Patient Info
      </Typography>
      <Divider />
      <Grid container spacing={4} sx={{ pt: 8 }}>
        <Grid xs={12} sm={4}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.FirstName" label="First Name" fullWidth />
          </Box>
        </Grid>
        <Grid xs={12} sm={4}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.MiddleName" label="Middle Name" fullWidth />
          </Box>
        </Grid>
        <Grid xs={12} sm={4}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.FamilyName" label="Family Name" fullWidth />
          </Box>
        </Grid>
        <Grid xs={12} sm={4}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.MotherName" label="Mother Name" fullWidth />
          </Box>  
        </Grid>
        <Grid xs={12} sm={4}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <DatePicker
              name="User.DateOfBirth"
              label="Date Of Birth"
              meta={meta}
            />
          </Box>
          <Typography variant="body2" color="textSecondary" sx={{ pl: 1 }}>
            Age: {calculateAgeFromDate(meta.value)} years
          </Typography>
        </Grid>
        <Grid xs={12} sm={2}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <SelectField
              name="User.Gender"
              label="Gender"
              data={gender}
              type={AddUserDoctorRequestUserGenderEnum}
              fullWidth
            />
          </Box>
        </Grid>
        <Grid xs={12} sm={2}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <SelectField
              name="User.BloodType"
              label="Blood Type"
              data={bloodTypes}
              type={AddUserDoctorRequestUserBloodTypeEnum}
              fullWidth
            />
          </Box>
        </Grid>
      </Grid>
      <Typography variant="h5" gutterBottom sx={{ pt: 8 }}>
        Identity
      </Typography>
      <Divider />
      <Grid container spacing={4} sx={{ pt: 6 }} justifyContent="center">
        <Grid xs={12} sm={2} md={6}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <SelectField
              name="User.MaritalStatus"
              label="Marital Status"
              data={maritalStatus}
              type={AddUserDoctorRequestUserMaritalStatusEnum}
              fullWidth
            />
          </Box>
        </Grid>
        <Grid container />
        <Grid xs={12} sm={6}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.Identity.IdentityID" label="Identity ID" fullWidth />
          </Box>       
        </Grid>
        <Grid container />
        <Grid xs={12} sm={4}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <UploadField
              name="User.Identity.IdentityImageUri"
              label="Identity Image"
              fileType={FileBodyTypeEnum.USERIDENTITYIMAGE}
              fullWidth
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
